import { Box, Typography } from "@mui/material";
import { images } from "../../assets";
import { useNavigate } from "react-router-dom";


export default function LoadingScreen({ text, redirectUrl }) {

    const navigate = useNavigate()

    const handleCancel = () => {
        if (redirectUrl) {
            // Redirect to the client's redirect_url
            window.location.href = redirectUrl;
        } else {
            // Fallback to going back
            navigate(-1);
        }
    };

    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px",
                backgroundColor: "#f5f5f7",
            }}
        >
            {/* Top - Logo */}
            <Box
                display="flex"
                justifyContent="center"
                sx={{ pt: { xs: 1, md: 1 } }}
            >
                <img
                    src={images.certageLogo}
                    alt="Logo"
                    style={{
                        width: "min(70vw, 300px)",
                        height: "auto",
                        maxHeight: "110px",
                    }}
                />
            </Box>

            {/* Center - Spinner and Text */}
            <div style={{ textAlign: "center" }}>
                <img src={images.spinner} alt="Loading..." />
                <Typography color="primary.text" style={{ marginTop: 2 }}>
                    {text}
                </Typography>
            </div>

            {/* Bottom - Cancel Button */}
            <div style={{ marginBottom: "20px" }}>
                {/* <Button variant="outlined" >

                </Button> */}
                <Typography color="#1818de" onClick={handleCancel} style={{ cursor: "pointer" }}>
                    Cancel Verification
                </Typography>
            </div>
        </div>
    );
}
